import { Modal, Stack, Text, Group, Badge, Box } from '@mantine/core';
import { Clock, AlertTriangle } from 'react-feather';

interface ConflictItem {
  date: string;
  reason?: string;
}

interface ConflictDetailsModalProps {
  opened: boolean;
  onClose: () => void;
  coachName: string;
  groupName: string;
  conflicts: ConflictItem[];
}

export function ConflictDetailsModal({
  opened,
  onClose,
  coachName,
  groupName,
  conflicts,
}: ConflictDetailsModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="xs">
          <AlertTriangle size={18} color="#E9A23B" />
          <Text fw={600}>Scheduling Conflicts</Text>
        </Group>
      }
      size="md"
    >
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          {coachName} has {conflicts.length} conflict{conflicts.length !== 1 ? 's' : ''} with{' '}
          <strong>{groupName}</strong> sessions.
        </Text>

        <Stack gap="xs">
          {conflicts.map((conflict, index) => {
            const date = new Date(conflict.date);
            const dateStr = date.toLocaleDateString('en-US', {
              weekday: 'short',
              month: 'short',
              day: 'numeric',
            });

            return (
              <Box
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '8px 12px',
                  backgroundColor: '#FEF3E7',
                  borderRadius: 6,
                  border: '1px solid #FED7AA',
                }}
              >
                <Clock size={14} color="#E9A23B" />
                <Text size="sm" fw={500}>
                  Session {index + 1}
                </Text>
                <Badge size="sm" variant="light" color="orange">
                  {dateStr}
                </Badge>
                {conflict.reason && (
                  <Text size="xs" c="dimmed" ml="auto">
                    {conflict.reason}
                  </Text>
                )}
              </Box>
            );
          })}
        </Stack>
      </Stack>
    </Modal>
  );
}
